/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ sets: NonNullable<unknown>, seconds: NonNullable<unknown> }} Workout_Quick_Dose_HoldInputs */

const en_us2_workout_quick_dose_hold = /** @type {(inputs: Workout_Quick_Dose_HoldInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.sets} × ${i?.seconds} s`)
};

const pt_br2_workout_quick_dose_hold = /** @type {(inputs: Workout_Quick_Dose_HoldInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.sets} × ${i?.seconds} s`)
};

const es_419_workout_quick_dose_hold = /** @type {(inputs: Workout_Quick_Dose_HoldInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.sets} × ${i?.seconds} s`)
};

const pt_pt2_workout_quick_dose_hold = /** @type {(inputs: Workout_Quick_Dose_HoldInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.sets} × ${i?.seconds} s`)
};

const fr_fr2_workout_quick_dose_hold = /** @type {(inputs: Workout_Quick_Dose_HoldInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.sets} × ${i?.seconds} s`)
};

const de_de2_workout_quick_dose_hold = /** @type {(inputs: Workout_Quick_Dose_HoldInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.sets} × ${i?.seconds} s`)
};

const it_it2_workout_quick_dose_hold = /** @type {(inputs: Workout_Quick_Dose_HoldInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.sets} × ${i?.seconds} s`)
};

/**
* | output |
* | --- |
* | "{sets} × {seconds} s" |
*
* @param {Workout_Quick_Dose_HoldInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const workout_quick_dose_hold = /** @type {((inputs: Workout_Quick_Dose_HoldInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Workout_Quick_Dose_HoldInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_workout_quick_dose_hold(inputs)
	if (locale === "es-419") return es_419_workout_quick_dose_hold(inputs)
	if (locale === "pt-PT") return pt_pt2_workout_quick_dose_hold(inputs)
	if (locale === "fr-FR") return fr_fr2_workout_quick_dose_hold(inputs)
	if (locale === "de-DE") return de_de2_workout_quick_dose_hold(inputs)
	if (locale === "it-IT") return it_it2_workout_quick_dose_hold(inputs)
	return en_us2_workout_quick_dose_hold(inputs)
});
export { workout_quick_dose_hold as "workout-quick.dose_hold" }